import React from "react";
import CheckBox from "../../checkbox/CheckBox";
import Icon from "../../icons/Icon";
import iconsList from "../../icons/iconsList";
import classes from "./TreeSelectRow.module.css";

const TreeSelectRow = ({ label, checked, onChange, indent = 16, expandable, expanded, onExpand }) => (
    <div
        className={classes.Row}
        style={{ paddingRight: indent }}
    >
        <CheckBox
            checked={checked}
            onChange={() => onChange()}
            dropClass={classes.RowCheckbox}
        />
        <span className={classes.RowLabel}>{label}</span>
        {expandable && (
            <button
                type="button"
                className={`${classes.ExpandBtn} ${expanded ? classes.ExpandBtnOpen : ""}`}
                onClick={(e) => { e.stopPropagation(); onExpand(); }}
            >
                <Icon name={iconsList.caretDown} size="16px" color="#925fe2" />
            </button>
        )}
    </div>
);

export default TreeSelectRow;
